module.exports = __webpack_public_path__ + "img/feature.293b70a.jpg";